import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './theme.css';

// Initialize Telegram WebApp
const tg = window.Telegram?.WebApp;

// Apply custom warm theme
const applyTheme = () => {
  document.documentElement.style.setProperty('--tg-theme-bg-color', 'transparent');
  document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', '#FDDCC4');
  document.documentElement.style.setProperty('--tg-theme-text-color', '#2D2424');
  document.documentElement.style.setProperty('--tg-theme-hint-color', '#C4A99A');
  document.documentElement.style.setProperty('--tg-theme-link-color', '#FF7B54');
  document.documentElement.style.setProperty('--tg-theme-button-color', '#FF7B54');
  document.documentElement.style.setProperty('--tg-theme-button-text-color', '#FFFFFF');
  document.body.style.background = 'linear-gradient(135deg, #FDDCC4 0%, #FFB8A0 100%)';
  document.body.style.minHeight = '100vh';
};

if (tg) {
  tg.ready();
  tg.expand();
  applyTheme();

  // Re-apply every time Telegram tries to override our theme
  tg.onEvent('themeChanged', applyTheme);

  tg.BackButton.onClick(() => {
    window.history.back();
  });
} else {
  applyTheme();
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
